import { render, staticRenderFns } from "./NavMenuPages.vue?vue&type=template&id=3d7b5738&"
import script from "./NavMenuPages.vue?vue&type=script&lang=js&"
export * from "./NavMenuPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports